import { useFormik } from 'formik';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { UploadImage } from "../../../components/common/uploadImage/UploadImage";
import { useNotification } from "../../../context/NotificationContext";
import { PLACEHOLDER_IMAGE_URL } from '../../../mock/constants';
import { LANGUAGES } from "../../../mock/languages";
import { getTeamMemberById, updateTeamMember } from '../../../services/aboutTeamSvc';
import { lang } from "../../../types/lang";
import imgBaseUrl from '../../../utils/imgBaseUrl';

export const TeamUpdatePage = () => {
    const navigate = useNavigate();
    const { formatMessage } = useIntl();
    const { showNotification } = useNotification();
    const [activeTab, setActiveTab] = useState<lang>("uz");
    const { memberId } = useParams()
    const { data: teamMemberById } = useQuery("getTeamMemberById", () => getTeamMemberById(Number(memberId!)), {
        enabled: !!memberId
    })

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            title: {
                uz: teamMemberById?.title_uz || '',
                ru: teamMemberById?.title_ru || '',
                en: teamMemberById?.title_en || '',
            },
            description: {
                uz: teamMemberById?.description_uz || '',
                ru: teamMemberById?.description_ru || '',
                en: teamMemberById?.description_en || '',
            },
            image: null,
            full_name: teamMemberById?.full_name || "",
        },
        onSubmit: async (values) => {
            const formData = new FormData();
            formData.append('title_uz', values.title.uz);
            formData.append('title_ru', values.title.ru);
            formData.append('title_en', values.title.en);
            formData.append('description_uz', values.description.uz);
            formData.append('description_ru', values.description.ru);
            formData.append('description_en', values.description.en);
            formData.append('full_name', values.full_name);

            if (values.image) {
                formData.append('image', values.image);
            }

            try {
                const res = await updateTeamMember(memberId, formData);
                if (res?.success) {
                    showNotification("Muvaffaqiyatli", "A'zo yangilandi", "success")
                    setTimeout(() => {
                        navigate(-1)
                    }, 1000)
                }
            } catch (e) {
                showNotification("Xatolik!", "", "error")
            }
        },
    });

    const handleTabChange = (lang) => {
        setActiveTab(lang);
    };

    return (
        <div>
            <div className={"card"}>
                <div className="card-header">
                    <h1 className="card-title">Jamoa a'zosi yangilash</h1>
                    <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
                        {LANGUAGES.map((lang) => (
                            <li className="nav-item" key={lang.key}>
                                <button
                                    className={`nav-link ${activeTab === lang.key ? 'active' : ''}`}
                                    onClick={() => handleTabChange(lang.key)}
                                >
                                    {lang.name}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="card-body">
                    <div id="kt_account_profile_details" className="collapse show">
                        <form
                            className="form"
                            onSubmit={formik.handleSubmit}
                            encType="multipart/form-data"
                        >
                            <div className="card-body p-9">
                                <div className="row mb-6">
                                    <label className="col-lg-4 col-form-label required fw-bold fs-6">
                                        A'zo ism, familiya, otasining ismi
                                    </label>
                                    <div className="col-lg-8 fv-row">
                                        <textarea
                                            className="form-control form-control-lg form-control-solid"
                                            placeholder="Namuna: Alisa Aliyevna Aliyeva"
                                            name={`full_name`}
                                            value={formik.values.full_name}
                                            onChange={formik.handleChange}
                                        />
                                        {formik.touched.full_name && formik.errors.full_name && (
                                            <div className="text-danger">{formik.errors.full_name}</div>
                                        )}
                                    </div>
                                </div>

                                <div className="row mb-6">
                                    <label className="col-lg-4 col-form-label required fw-bold fs-6">
                                        Lavozimi
                                    </label>
                                    <div className="col-lg-8 fv-row">
                                        <textarea
                                            className="form-control form-control-lg form-control-solid"
                                            placeholder="Lavozimi"
                                            name={`title.${activeTab}`}
                                            value={formik.values.title[activeTab]}
                                            onChange={formik.handleChange}
                                        />
                                        {formik.touched.title?.[activeTab] && formik.errors.title?.[activeTab] && (
                                            <div className="text-danger">{formik.errors.title[activeTab]}</div>
                                        )}
                                    </div>
                                </div>

                                <div className="row mb-6">
                                    <label className="col-lg-4 col-form-label fw-bold fs-6">
                                        <span className="required">Haqida</span>
                                    </label>
                                    <div className="col-lg-8 fv-row">
                                        <textarea
                                            className="form-control form-control-lg form-control-solid"
                                            placeholder="Haqida"
                                            name={`description.${activeTab}`}
                                            value={formik.values.description[activeTab]}
                                            onChange={formik.handleChange}
                                        />
                                        {formik.touched.description?.[activeTab] && formik.errors.description?.[activeTab] && (
                                            <div className="text-danger">{formik.errors.description[activeTab]}</div>
                                        )}
                                    </div>
                                </div>

                                <div className="row mb-6">
                                    <label className="col-lg-4 col-form-label required fw-bold fs-6">
                                        Profil rasmi
                                    </label>
                                    <div className="col-lg-8 fv-row">
                                        <UploadImage defaultImage={teamMemberById?.image ? imgBaseUrl(teamMemberById?.image!) : PLACEHOLDER_IMAGE_URL} imageSizes={"banner"} onImageUpload={(file) => {
                                            if (file) {
                                                formik.setFieldValue('image', file);
                                            }
                                        }} />
                                        {formik.touched.image && formik.errors.image && (
                                            <div className="text-danger">{formik.errors.image}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer">
                                <div className="justify-content-end d-flex gap-2">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => navigate(-1)}
                                        type="button"
                                    >
                                        {formatMessage({ id: "Bekor qilish" })}
                                    </button>
                                    <button
                                        className="btn btn-primary"
                                        type="submit"
                                        disabled={formik.isSubmitting}
                                    >
                                        {formik.isSubmitting ? "Saqlanmoqda..." : "Saqlash"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};